import * as ElementPlusIconsVue from '@ant-design/icons-vue'

export const initIcons = (app) => {
  for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
  }
}
